// extracted by mini-css-extract-plugin
module.exports = {"container":"PsychometricDetail_container__3-7y4","loadingWrapper":"PsychometricDetail_loadingWrapper__1kXWF"};